import React, { useState } from "react";
import { Breathing, Image } from "react-shimmer";
import { Button } from "semantic-ui-react";
import Delete from "./Delete";

const Card = ({ image, admin }) => {
  const [deleteId, setDeleteId] = useState(null);
  return (
    <>
      <div className="card">
        <div className="card-body">
          {admin && (
            <Button
              circular
              color="red"
              icon="trash"
              onClick={() => setDeleteId(image)}
            />
          )}
          <Image
            src={image.fileURL}
            fallback={<Breathing width={400} height={300} />}
          />
        </div>
      </div>
      {deleteId && (
        <Delete deleteId={deleteId} close={() => setDeleteId(null)} />
      )}
    </>
  );
};

export default Card;
